<template>
  <div class="pop">
    <div class="bg-in">
<!--      src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/vipbanner/5psq6q3h4nflnqz0nryr0yubyqye09qavip_pop_pge.png"-->
      <img
        src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/8950bpli0e890dryi3xj0k19ltm768ebpop_PGE.png"
        style="max-width: 90vw; height: auto; border-radius: 10px"
        @click="goToPromotion"
      >
      <div class="cancel-btn" @click="close">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
  </div>
</template>

<script>
import cancelWhite from '@/assets/images/common/cancelWhite.svg'
import IFrame3Part from '@/components/IFrame3Part/index'

export default {
  name: 'VipPop',
  props: ['handleClose'],
  data () {
    return {
      cancelWhite,
      iFrameSrc: '',
      showPromotion: false,
      internation: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      delayedAWhile: false
    }
  },
  watch: {
  },
  components: {
    IFrame3Part
  },
  mounted () {
    this.onInit()
  },
  methods: {
    onInit: function () {
      let that = this
      setTimeout(() => {
        that.delayedAWhile = true
        return null
      }, 3000)
    },
    close () {
      this.handleClose()
    },
    goToPromotion () {
      this.close()
      // this.$router.push('/vip')
      let end = ''
      if (localStorage.getItem('apkV') && localStorage.getItem('cid')) {
        end = '?cid=' + localStorage.getItem('cid') + '&v=' + localStorage.getItem('apkV')
      } else if (localStorage.getItem('apkV') && !localStorage.getItem('cid')) {
        end = '?v=' + localStorage.getItem('apkV')
      } else if (!localStorage.getItem('apkV') && localStorage.getItem('cid')) {
        end = '?cid=' + localStorage.getItem('cid')
      }
      window.location.href = 'https://www.pgebet.net' + end
    }
  }
}
</script>

<style lang="less" scoped>
  .pop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    z-index: 9;
    padding: 40px 20px;
    box-sizing: border-box;
    overflow: auto;

    .bg-in {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50.05%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 96vw;

      .cancel-btn {
        width: 28px;
        height: 28px;
        margin-top: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VipPop/index.vue